export default __webpack_public_path__ + "static/media/send_white.ecc3ff4e.svg";